import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import translationsStore from '../translationsStore';
import ldapValidator from '../ldap/ldapValidtor';

class LDAPStepperStore {

    @setter @observable stepIndex = 0;
    @setter @observable finished = false;

    @action handleNext = (stepsLength) => {

        this.stepIndex = this.stepIndex + 1;
        this.finished = this.stepIndex >= stepsLength + 1;
    }

    handlePrev = () => {

        if (this.stepIndex > 0) {

            this.stepIndex = this.stepIndex - 1;
        }
    }
}

export default new LDAPStepperStore();


// WEBPACK FOOTER //
// ./src/stores/stepper/ldapStepperStore.js